module.exports = __webpack_public_path__ + "img/17.a983ee73.svg";